import { Router } from "@angular/router";
import { IUser } from "./../models/user";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiconstants } from "../constants/api.constant";
import { StorageService } from "libs/core/src/lib/services/storage.service";
import { IResponse } from "../models/response";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public $user: BehaviorSubject<IUser> = new BehaviorSubject<IUser>(null);
  public $privilegesInit: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private _http: HttpClient,
    private _storageService: StorageService,
    private router: Router,
  ) { }

  login(params: any): Observable<IUser> {
    return this._http.post(apiconstants.API_LOGIN, params).pipe(
      map((response: IResponse) => {
        this.$user.next(<IUser>response.data);
        if (this.$user.value.loginactivity_id == "") {
          this.isLoggedIn.next(true);
        } else {
          this.isLoggedIn.next(false);
        }
        return this.$user.value;
      })
    );
  }
  loginByToken(token: string): Observable<IUser> {
    this._storageService.store("token", token);
    return this._http.get(apiconstants.API_STATUS).pipe(
      map((response: IResponse) => {
        this.$user.next(<IUser>response.data);
        this.isLoggedIn.next(true);
        return <IUser>this.$user.value;
      })
    );
  }
  status(): Observable<IUser> {
    return this._http.get(apiconstants.API_STATUS).pipe(
      map((response: IResponse) => {
        this.$user.next(<IUser>response.data);
        this.isLoggedIn.next(true);
        this.rolePriviledge();
        return <IUser>this.$user.value;
      })
    );
  }
  rolePriviledge() {
    this._http
      .get(apiconstants.API_ROLE_PRIVILEGDGE)
      .subscribe((res: any) => {
        let result = {};

        JSON.parse(
          localStorage.getItem("user")
        ).parentuserprojectrolemappinglist.forEach((mapping) => {
          if (mapping.project) {
            const projectId = mapping.project.id;
            const roleName = mapping.securityrole.name
              .toUpperCase()
              .replace(/[\s/]/g, "_");

            const matchedPrivileges = res.data
              .filter((rp) => rp.securityRole === roleName)
              .flatMap((rp) => rp.actions);

            if (!result[projectId]) {
              result[projectId] = [];
            }

            // Combine and deduplicate privileges
            result[projectId] = Array.from(
              new Set([...result[projectId], ...matchedPrivileges])
            );
          }
        });
        localStorage.setItem("projectprivileges", JSON.stringify(result));
        console.log('projectprivileges==>', result);
        this.$privilegesInit.next(result);

      });
  }

  logout() {
    this._storageService.clearAll();
    this.isLoggedIn.next(false);
    this.$user.next(null);
    this.router.navigate(["/login"]);
  }

  get loginStatus() {
    return this.isLoggedIn.value;
  }

  get user() {
    return this.$user.value;
  }

  login2fa(params: any): Observable<IUser> {
    return this._http.post(apiconstants.API_2FALOGIN, params).pipe(
      map((response: IResponse) => {
        this.$user.next(<IUser>response.data);
        if (this.$user.value.loginactivity_id == "") {
          this.isLoggedIn.next(true);
        } else {
          this.isLoggedIn.next(false);
        }
        return this.$user.value;
      })
    );
  }

  resendMFACode(loginactivityid: any) {
    return this._http
      .post(apiconstants.API_2FA_RESEND, { loginactivityid })
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  getAllUsers(): Observable<any> {
    return this._http.get(apiconstants.API_GET_ALL_USERS).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getAllSecurityRoles(): Observable<any> {
    return this._http.get(apiconstants.API_GET_ALL_SECURITY_ROLES).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getUserProjectRoles(selectedUser?: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_USER_PROJECT_ROLES + "/" + (selectedUser || ""))
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
  getUserProjectRoleMapping(projectId?: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_USER_PROJECT_ROLES + "/project/" + projectId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  createUser(userDetails: any) {
    return this._http.post(apiconstants.API_CREATE_USER, userDetails).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateUser(userId: string, userDetails: any) {
    return this._http
      .put(apiconstants.API_UPDATE_USER + "/" + userId, userDetails)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  getSecurityRole(roleId: string) {
    return this._http
      .get(apiconstants.API_SPECIFIC_SECURITY_ROLE + "/" + roleId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getAllPrivileges() {
    return this._http.get(apiconstants.API_PRIVILEGES).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  updateSecurityRole(roleId, payload) {
    return this._http
      .put(apiconstants.API_SPECIFIC_SECURITY_ROLE + `/${roleId}`, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  createSecurityRole(payload) {
    return this._http
      .post(apiconstants.API_SPECIFIC_SECURITY_ROLE, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  deleteSecurityRole(roleId: string): Observable<any> {
    return this._http
      .delete(apiconstants.API_SPECIFIC_SECURITY_ROLE + "/" + roleId)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  forgotPasswordSendOtp(payload: any) {
    return this._http
      .post(apiconstants.API_FORGOT_PASSWORD_SEND_OTP, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  validateForgotPasswordOtp(payload: any) {
    return this._http
      .post(apiconstants.API_FORGOT_PASSWORD_VALIDATE_OTP, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  submitForgotNewPassword(payload: any) {
    return this._http
      .post(apiconstants.API_FORGOT_PASSWORD_UPDATE, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  resendOtp(payload: any) {
    return this._http
      .post(apiconstants.API_FORGOT_PASSWORD_RESEND, payload)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

}
